(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/error/middleware-payment-error.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/error/middleware-payment-error.js');
'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  MiddlewareErrorCodes,
  MiddlewareErrorMessages
} = svs.components.payment.common.error.constants;
const {
  PaymentError
} = svs.components.payment.common.error;

class MiddlewarePaymentError extends PaymentError {
  constructor(_ref) {
    let {
      clientCode,
      code,
      extraData
    } = _ref;
    const message = MiddlewareErrorMessages[clientCode] ? MiddlewareErrorMessages[clientCode] : 'Middleware error';
    super({
      clientCode,
      code,
      extraData,
      message
    });
    this.name = 'MiddlewarePaymentError';
  }
  get handledError() {
    return true;
  }
}
_defineProperty(MiddlewarePaymentError, "ErrorCodes", MiddlewareErrorCodes);
setGlobal('svs.components.payment.common.error.MiddlewarePaymentError', MiddlewarePaymentError);

 })(window);